import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { SupplierHomePage } from "./supplier-home.page";

const routes: Routes = [
  {
    path: "**",
    component: SupplierHomePage,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SupplierHomePageRoutingModule { }
